import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  const [errorMsg, setErrorMsg] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/", { replace: true });
      return;
    }
    const session_id = decodeURIComponent(match[1]);
    (async () => {
      try {
        const res = await api.post("/auth/session", { session_id });
        setUser(res.data.user);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/app/dashboard", { replace: true, state: { user: res.data.user } });
      } catch (err) {
        const detail = err.response?.data?.detail || "Access denied. Only authorized partner accounts (kurubhandari@u.nus.edu, alvanreal@gmail.com) can sign in.";
        setErrorMsg(detail);
      }
    })();
  }, [navigate, setUser]);

  if (errorMsg) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-[#0A1128] text-white p-4">
        <div className="max-w-md w-full bg-[#152243] border border-red-500/30 rounded-lg p-8 text-center shadow-2xl">
          <div className="w-12 h-12 rounded-full bg-red-500/10 border border-red-500/30 flex items-center justify-center mx-auto mb-4">
            <ShieldAlert className="w-6 h-6 text-red-400" />
          </div>
          <div className="label-eyebrow text-[#C5A880] mb-2">Alpine Straits Desk</div>
          <h2 className="font-serif-display text-2xl text-white mb-3">Partner Access Restricted</h2>
          <p className="text-sm text-slate-300 mb-6 leading-relaxed">
            {errorMsg}
          </p>
          <button
            onClick={() => navigate("/", { replace: true })}
            className="w-full bg-[#C5A880] hover:bg-[#b5976f] text-[#0A1128] font-semibold py-2.5 px-4 rounded transition-colors text-sm"
          >
            Return to Homepage
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center min-h-screen bg-[#0A1128] text-white">
      <div className="text-center">
        <div className="label-eyebrow text-[#C5A880] mb-3">Alpine Straits</div>
        <p className="font-serif-display text-2xl">Signing you in…</p>
      </div>
    </div>
  );
}
